var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.875,
    height: 19.406,
    viewBox: "0 0 25.875 19.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "people",
    d: "M24.258,21.406a1.584,1.584,0,0,0,1.617-1.617c0-1.617-1.617-6.469-8.086-6.469S9.7,18.172,9.7,19.789a1.584,1.584,0,0,0,1.617,1.617Zm-12.9-1.617-.036-.006A4.963,4.963,0,0,1,12.549,17a6.472,6.472,0,0,1,5.24-2.064A6.482,6.482,0,0,1,23.029,17a4.979,4.979,0,0,1,1.229,2.782l-.013,0-.023,0Zm6.433-9.7a3.234,3.234,0,1,0-3.234-3.234A3.234,3.234,0,0,0,17.789,10.086Zm4.852-3.234A4.852,4.852,0,1,1,17.789,2a4.852,4.852,0,0,1,4.852,4.852ZM11.217,13.773a9.509,9.509,0,0,0-1.989-.4q-.569-.054-1.142-.053C1.617,13.32,0,18.172,0,19.789a1.429,1.429,0,0,0,1.617,1.617H8.435a3.619,3.619,0,0,1-.349-1.617,7.421,7.421,0,0,1,1.763-4.7A8.557,8.557,0,0,1,11.217,13.773Zm-3.26,1.164a8.883,8.883,0,0,0-1.488,4.852H1.617A4.962,4.962,0,0,1,2.846,17a6.426,6.426,0,0,1,5.11-2.062ZM2.426,7.66a4.852,4.852,0,1,1,4.852,4.852A4.852,4.852,0,0,1,2.426,7.66ZM7.277,4.426A3.234,3.234,0,1,0,10.512,7.66,3.234,3.234,0,0,0,7.277,4.426Z",
    transform: "translate(0 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.d1da37b1731c4d00f13250f3bcae1d92.svg";
export { ForwardRef as ReactComponent };